export default {
  LOCATION_PICKER_ALL: "all",
  QUEUE_ALL: "All Queues",
  SHARED_SETTINGS: "Shared Settings",
}
